<template>
  <div class="project-account-manage">
    <template v-if="!dialog.show">
      <div class="app-title">账号管理</div>
      <div class="app-control app-table-control">
        <el-button type="primary" @click="add">新增账号</el-button>
        <div class="right-region">
          <el-input placeholder="请输入名称" v-model="search.value" clearable></el-input>
          <el-button type="primary" @click="searchParams">搜索</el-button>
          <el-button @click="resetParams">重置</el-button>
        </div>
      </div>
      <el-table :data="datas" v-loading="loading">
        <el-table-column label="手机号" prop="account_attr_data.account_attr_phone"></el-table-column>
        <el-table-column label="名称" prop="account_attr_data.account_attr_name"></el-table-column>
        <el-table-column label="职位" prop="account_attr_data.account_attr_title"></el-table-column>
        <el-table-column label="权限" prop="auth"></el-table-column>
        <!-- <el-table-column label="状态" prop="status"></el-table-column> -->
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button type="text" @click="edit(row.account_id)">编辑</el-button>
            <el-button type="text" @click="del(row.account_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
    </template>
    <project-account-info v-else :accountId="dialog.id" @submit="initDatas" @cancel="dialog.show = false"></project-account-info>
  </div>
</template>

<script>
  import ProjectService from '@/io/project.js';
  import ProjectAccountInfo from '@/views/ProjectAccountInfo.vue';

  export default {
    name: 'ProjectAccountManage',
    data() {
      return {
        id: this.$route.params.id,
        dialog: {
          show: false,
          title: '',
          id: null
        },
        search: {
          value: ''
        },
        datas: [],
        loading: false,
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        }
      }
    },
    components: {
      ProjectAccountInfo,
    },
    mounted() {
      this.initDatas();
    },
    methods: {
      initDatas() {
        this.loading = true;
        ProjectService.accountListPage(
          this.id,
          this.page.currentPage,
          this.search.value
        ).then(res => {
          let source = res.data;
          if (!source.data.length && this.page.currentPage > 1) {
            this.page.currentPage--;
            this.initDatas();
          } else {
            this.datas = source.data.map(val => {
              val.status = val.account_status === 1 ? '开启' : '关闭';
              val.auth = val.account_permission_data.map(m => {
                return m.menu_name;
              }).join('、');
              return val;
            });
            this.page.pageSize = source.per_page;
            this.page.total = source.total;
          }
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      add() {
        this.dialog.title = '新增账号';
        this.dialog.id = null;
        this.dialog.show = true;
      },
      edit(id) {
        this.dialog.title = '编辑账号';
        this.dialog.id = id;
        this.dialog.show = true;
      },
      del(id) {
        this.$confirm(
          '确认删除?',
          '提示',
          {
            type: 'warning'
          }
        ).then(() => {
          return ProjectService.delAccount(this.id, id);
        }).then(res => {
          return this.initDatas();
        }).then(res => {
          this.$message.success('删除成功');
        }).catch(() => {});
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search.value = '';
        this.searchParams();
      }
    },
  }
</script>

<style lang="less" scoped>

</style>